import React, {useEffect, useState} from "react";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {SwitchButton} from '../module/switchButton';

const ImageSlider = props => {
    let [imageindex, setImageIndex] = useState(0);
    // let videoindex = 0;
    let [switchButtonchecked, setSwitchButtonChecked] = useState(false);

    useEffect(() => {
        updateItems();
    })

    const updateItems = () => {
        let arrowsLeft = document.querySelectorAll('.image-arrow-back');
        let arrowsRight = document.querySelectorAll('.image-arrow-forward');

        if (switchButtonchecked) {
           arrowsLeft[props.videoindex].classList.add('hide');
           arrowsRight[props.videoindex].classList.add('hide');
        } else if ((arrowsLeft[props.videoindex] || arrowsRight[props.videoindex])) {
            arrowsLeft[props.videoindex].classList.remove('hide');
            arrowsRight[props.videoindex].classList.remove('hide');
        }
    }

    const back = () => {
        if (switchButtonchecked) return;
        if (imageindex <= 0) imageindex = props.imageposter.length;
        setImageIndex(imageindex-=1);
    }

    const forward = () => {
        if (switchButtonchecked) return;
        if (imageindex === props.imageposter.length-1) imageindex = -1;
        setImageIndex(imageindex+=1);
    }

    const toggleCheckedSwitchButton = () => {
        setSwitchButtonChecked(!switchButtonchecked);
        updateItems();
    }


    return (
        <div className="imageSlider-wrapper">
            <div className={props.showModalImages?"imagePosterBig":"imageposter-wrapper"}>
            {!switchButtonchecked?
                <div
                    onClick={props.showImages?props.showImages:null}
                    className="imagePoster"
                    style={{backgroundImage:`url(${props.imageposter[imageindex].product_img})`}}>
                </div>
                :
                <iframe
                    className="imagePoster"
                    title={props.videoposter[0].titel}
                    src={props.videoposter[0].product_video}
                    frameBorder="0"
                    allowFullScreen="allowfullscreen">
                </iframe>
            }
            </div>
            <SwitchButton
                labelLeft={props.switchButtonLabelLeft}
                labelRight={props.switchButtonLabelRight}
                switchButtonchecked={switchButtonchecked}
                toggleCheckedSwitchButton={toggleCheckedSwitchButton}
            />
            <div className="arrow-wrapper">
                 <ArrowBackIosIcon onClick={back} className="image-arrow-back" />
                 <ArrowForwardIosIcon onClick={forward} className="image-arrow-forward" />
            </div>
        </div>
    )
}

export default ImageSlider;